import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import {
    VStack,
    HStack,
    Text,
    Input,
    Button,
} from '@chakra-ui/react';
import { useAppStore } from '../../state/store';
import { ManageDialogFrame, ManageDialogCloseFooter, ManageDialogPrimaryButton } from './ManageDialogFrame';
import { useBIMStore } from '../../state/useBIMStore';

interface FormState {
    name: string;
    number: string;
    client: string;
    address: string;
}

export function LocationDialog() {
    const { t } = useTranslation();
    const isOpen = useAppStore((state) => state.manageDialog === 'location');
    const onClose = useAppStore((state) => state.closeManageDialog);
    const project = useBIMStore((state) => state.project);
    const updateProjectInfo = useBIMStore((state) =>state.updateProjectInfo); const [form, setForm] = useState<FormState>({ name: '', number: '', client: '', address: '' });

    useEffect(() => {
        if (isOpen) {
            setForm({
                name: project.name,
                number: project.number,
                client: project.client,
                address: project.address,
            });
        }
    }, [isOpen, project.name, project.number, project.client, project.address]);

    const isDirty =
        form.name !== project.name ||
        form.number !== project.number ||
        form.client !== project.client ||
        form.address !== project.address;

    const handleApply = () => {
        updateProjectInfo(form);
        onClose();
    };

    const field = (
        label: string,
        key: keyof FormState,
        placeholder: string
    ) => (
        <HStack justify="space-between" align="center">
            <Text fontSize="sm" color="var(--color-text-secondary)" whiteSpace="nowrap" width="130px">
                {label}
            </Text>
            <Input
                size="sm"
                placeholder={placeholder}
                value={form[key]}
                onChange={(e) => setForm((prev) => ({ ...prev, [key]: e.target.value }))}
                bg="var(--color-bg-tertiary)"
                borderColor="var(--color-border)"
            />
        </HStack>); return (<ManageDialogFrame
            title={t('manage.projectLocation')}
            isOpen={isOpen}
            onClose={onClose}
            footer={
                <ManageDialogCloseFooter
                    onClose={onClose}
                    extra={
                        <ManageDialogPrimaryButton
                            label={t('manage.apply')}
                            onClick={handleApply}
                            isDisabled={!isDirty}
                        />
                    }
                />
            }
        >
            <VStack spacing={3} align="stretch">
                {field('Project Name', 'name', 'Project name')}
                {field('Project Number', 'number', 'Project number')}
                {field('Client', 'client', 'Client name')}
                {field('Address', 'address', 'Street, city, country')}
            </VStack>
        </ManageDialogFrame>
    );
}
